export function getChunkSizeToRender(length, size) {
    return Math.floor(length / size + 1);
}
//# sourceMappingURL=getChunkSizeToRender.js.map